import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'


import ErrorMessage from '../../Shared/ErrorMessage'
import PrimaryButton, { TransparentBgButton } from '../../Shared/Button'

export default function FormButtons({ submitForm, onCancelClick, loading, error, hasChange }) {
  const { t } = useTranslation()

  return (
    <div className="row mb-md-5 mb-lg-0">
      <div className="col-12 mb-md-5">
        {error && <ErrorMessage classNames={'mt-1 mb-4'} danger>{t(error)}</ErrorMessage>}

        <div className="d-flex flex-row justify-content-between">
          <div className="text-left">
            <TransparentBgButton
              className="bt"
              onClick={onCancelClick}
              text={t('Simulation.form.cancel')}
              fullWidth={false}
              color="navy"
            />
          </div>
          
          <div className="text-right">
            <PrimaryButton
              type="button"
              classNames="simulation-btn"
              onClick={submitForm}
              text={loading ? t('common.sending') : t('Simulation.form.btn')}
              disabled={loading || hasChange === false}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

FormButtons.propTypes = {
  submitForm: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.string,
  hasChange: PropTypes.bool,
}
